import React, { useEffect, useState } from "react";
import AppNavbar from "../../components/common/AppNavbar";
import { fetchNewsByCategory } from "../../services/api";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import ImmCountry from "../../components/Immigration/Immigation";
import ImmNewsSection from "../../components/Immigration/ImmNewsSection";
import ImmigrationHub2026 from "./ImmNews/ImmNews";
import { Image } from "react-bootstrap";

function Immigration() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const data = await fetchNewsByCategory("immigration");
      setNews(data);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <Loading />;

  return (
    <>
      <AppNavbar />
      <div style={{ padding: "20px" }}>
        <div id="container">
          {/* <NewsSection
            title="Immigration News"
            articles={news}
            category="immigration"
          /> */}
          <ImmigrationHub2026 />
          <div className="text-center p-2">
            <small>Advertisement</small>
            <Image
              className="mx-auto d-block"
              src="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0057.jpg"
              fluid
            />
          </div>
          <ImmCountry />
        </div>
      </div>
    </>
  );
}

export default Immigration;
